var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54167 1.66699C2.96637 1.66699 2.5 2.13336 2.5 2.70866C2.5 3.28396 2.96637 3.75033 3.54167 3.75033H7.22982V7.4576H6.10684C5.31652 7.4576 4.63487 8.01266 4.47474 8.78659L2.9144 16.3283C2.7004 17.3626 3.49025 18.3326 4.5465 18.3326H15.4529C16.5092 18.3326 17.299 17.3626 17.085 16.3283L15.5247 8.78659C15.3645 8.01266 14.6829 7.4576 13.8926 7.4576H12.7715V3.75033H16.4583C17.0336 3.75033 17.5 3.28396 17.5 2.70866C17.5 2.13336 17.0336 1.66699 16.4583 1.66699H3.54167ZM11.7298 3.75033H8.27148V7.4576H11.7298V3.75033ZM9.99954 15.1451C11.244 15.1451 12.2495 14.1395 12.2495 12.8951C12.2495 11.6507 11.244 10.6451 9.99954 10.6451C8.75513 10.6451 7.74954 11.6507 7.74954 12.8951C7.74954 14.1395 8.75513 15.1451 9.99954 15.1451Z",
    fill: "#7239EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale);
export default __webpack_public_path__ + "static/media/icon-scale.afdb5ee40b83aa7582e344214bec6d09.svg";
export { ForwardRef as ReactComponent };